import { createRouter, createWebHistory } from "vue-router";
import store from "../store/index";

const HomeView = () => import("../components/views/HomeView.vue");
const HelpView = () => import("../components/views/HelpView.vue");
const ScoreCardView = () => import("../components/views/ScoreCardView.vue");
const AdminView = () => import("../components/views/AdminView.vue");
const PageNotFound = () => import("../components/views/PageNotFound.vue");

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      title: "Score Cards - Printable and Online Game Scorecards",
      description:
        "Create, save, print, and manage scorecards for card games, tabletop games, clubs, teams, and recurring players.",
    },
  },
  {
    path: "/help",
    name: "help",
    component: HelpView,
    meta: {
      title: "Score Cards Help - Game Scorecard Guides",
      description:
        "Help and printable guidance for using Score Cards to create, save, print, and manage game scorecards.",
    },
  },
  {
    path: "/scorecard",
    name: "scoreCard",
    component: ScoreCardView,
    meta: {
      requiresAuth: true,
      title: "Score Card - Score Cards",
      description: "Private scorecard workspace for registered Score Cards users.",
      robots: "noindex, nofollow",
    },
  },
  {
    path: "/admin",
    name: "admin",
    component: AdminView,
    meta: {
      title: "Admin - Score Cards",
      description: "Administrative tools for Score Cards.",
      robots: "noindex, nofollow",
    },
  },
  {
    path: "/:catchAll(.*)",
    name: "PageNotFound",
    component: PageNotFound,
    meta: {
      title: "Page Not Found - Score Cards",
      description: "The requested Score Cards page could not be found.",
      robots: "noindex, nofollow",
    },
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach((to) => {
  /* If this route requires auth, check if logged in and
     if not, redirect to home page. */
  let userStatus = store.getters["auth/userLoggedIn"];
  if (to.meta.requiresAuth && !userStatus) {
    return { name: "home" };
  }
});

function upsertMetaByName(name, content) {
  let element = document.querySelector(`meta[name="${name}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute("name", name);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

function upsertMetaByProperty(property, content) {
  let element = document.querySelector(`meta[property="${property}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute("property", property);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

function upsertCanonical(href) {
  let element = document.querySelector('link[rel="canonical"]');
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", "canonical");
    document.head.appendChild(element);
  }
  element.setAttribute("href", href);
}

router.afterEach((to) => {
  const title = to.meta.title || "Score Cards";
  const description =
    to.meta.description ||
    "Score Cards helps groups create, save, print, and manage reusable game scorecards.";
  const robots = to.meta.robots || "index, follow";
  const canonicalUrl = new URL(to.path, window.location.origin).toString();

  document.title = title;
  upsertMetaByName("description", description);
  upsertMetaByName("robots", robots);
  upsertMetaByProperty("og:title", title);
  upsertMetaByProperty("og:description", description);
  upsertMetaByProperty("og:url", canonicalUrl);
  upsertCanonical(canonicalUrl);
});

export default router;
